document.querySelectorAll('[data-blog-archive]').forEach((archive) => {
    const posts = archive.querySelector('[data-blog-posts]');
    const switches = archive.querySelectorAll('[data-blog-layout]');

    const setLayout = (layout) => {
        posts.dataset.layout = layout;
        switches.forEach((link) => {
            const active = link.dataset.blogLayout === layout;
            link.classList.toggle('is-active', active);
            link.setAttribute('aria-pressed', String(active));
        });
        archive.querySelectorAll('.tt-blog-pagination a').forEach((link) => {
            const url = new URL(link.href);
            url.searchParams.set('layout', layout);
            link.href = url.href;
        });
    };

    switches.forEach((link) => {
        link.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            setLayout(link.dataset.blogLayout);
            const url = new URL(window.location.href);
            url.searchParams.set('layout', link.dataset.blogLayout);
            window.history.replaceState(null, '', url);
        });
        link.addEventListener('keydown', (event) => {
            if (event.key === ' ') {
                event.preventDefault();
                link.click();
            }
        });
    });

    // Measure the visible sticky/fixed headers, including the public admin bar.
    let scheduled = false;
    const updateOffset = () => {
        let bottom = 0;
        document.querySelectorAll('.tt-header-main, .tp-header-sticky, .header-sticky, #admin_bar, #admin-bar').forEach((header) => {
            const style = getComputedStyle(header);
            const rect = header.getBoundingClientRect();
            if (['fixed', 'sticky'].includes(style.position) && rect.height && rect.bottom > 0 && rect.top < 150) {
                bottom = Math.max(bottom, rect.bottom);
            }
        });
        archive.style.setProperty('--blog-sticky-top', `${Math.max(16, bottom + 16)}px`);
        scheduled = false;
    };
    const scheduleOffset = () => {
        if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(updateOffset);
        }
    };
    window.addEventListener('scroll', scheduleOffset, {passive: true});
    window.addEventListener('resize', scheduleOffset);
    updateOffset();
});
